export const HEADER_TOOLBAR_PREFIX = "HeaderToolbar";

export const HEADER_TOOLBAR_CLASSES = {
  menuButton: `${HEADER_TOOLBAR_PREFIX}-menuButton`,
  logo: `${HEADER_TOOLBAR_PREFIX}-logo`,
  buttonGroup: `${HEADER_TOOLBAR_PREFIX}-buttonGroup`,
  shoppingListButton: `${HEADER_TOOLBAR_PREFIX}-shoppingListButton`,
  shoppingBagButton: `${HEADER_TOOLBAR_PREFIX}-shoppingBagButton`,
};
